import { range } from 'lodash';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';

const Marquee = () => {
  const { t } = useTranslation();

  const lastScrollTop = useRef(0);
  const [translateX, setTranslateX] = useState(-250);

  useEffect(() => {
    function onScroll() {
      const isMac = navigator.platform.toUpperCase().includes('MAC');
      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (scrollTop > lastScrollTop.current) {
        setTranslateX(x => x - (isMac ? 0.25 : 10));
      } else if (scrollTop < lastScrollTop.current) {
        setTranslateX(x => x + (isMac ? 0.25 : 10));
      }

      lastScrollTop.current = scrollTop <= 0 ? 0 : scrollTop;
    }

    document.addEventListener('scroll', onScroll, false);

    return () => document.removeEventListener('scroll', onScroll, false);
  }, []);

  return (
    <div className="relative section full overflow-x-hidden py-12">
      <p
        className="h1 w-full flex space-x-3 whitespace-nowrap"
        style={{ transform: `translateX(${translateX}%)` }}
      >
        {range(20).map((_, idx) => (
          <span key={idx} className="odd:opacity-20 even:opacity-100">
            {t('P_ABOUT.SECTION-4.MARQUEE')}
          </span>
        ))}
      </p>
    </div>
  );
};

export default Marquee;
